//
// トースト表示制御
//

export function toast(message, root){
  const rootWidth = document.defaultView.getComputedStyle(root, null).width;

  const toastElement = document.createElement("div");
  toastElement.classList.add("toast");
  toastElement.style["max-width"] = rootWidth;

  toastElement.innerText = message;
  root.insertBefore(toastElement, null);

  setTimeout(() => {
    toastElement.classList.add("on");
  }, 0);

  setTimeout(() => {
    toastElement.classList.add("off");
  }, 3000);

  setTimeout(() => {
    root.removeChild(toastElement);
  }, 4000);
}
